import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import "./PerDayGraph.scss"

const PerDayGraph = ({ data1 }) => {
  return (
    <div className="per-day-graph">
      <LineChart
        width={650}
        height={300}
        data={data1}
        margin={{ top: 5, right: 95, left: 1, bottom: 5 }}
      >
        <XAxis dataKey="day" />
        <YAxis />
        <CartesianGrid strokeDasharray="3 3" stroke='black'/>
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="orders" stroke="#ff3f3f" activeDot={{ r: 8 }} strokeWidth={3} />
      </LineChart>
    </div>
  );
};

export default PerDayGraph;
